export default __webpack_public_path__ + "static/cover_360-259645a5a8467609464aeab388133a60.jpg";